/**
 * Parse WebSocket frames for LIVE_MEETING_INSIGHTS_REALTIME_V1.
 */

import {
  LIVE_MEETING_INSIGHTS_REALTIME_KIND,
  type LiveMeetingInsightsRealtimeEnvelopeV1,
} from '@core/types/liveMeetingInsightsRealtime'

function isValidLiveMeetingInsightsRealtimeEnvelope(
  envelope: unknown,
): envelope is LiveMeetingInsightsRealtimeEnvelopeV1 {
  if (!envelope || typeof envelope !== 'object') return false
  const e = envelope as Record<string, unknown>
  if (e.kind !== LIVE_MEETING_INSIGHTS_REALTIME_KIND) return false
  if (e.schemaVersion !== 1) return false
  if (typeof e.meetingId !== 'string' || !e.meetingId.trim()) return false
  if (!e.insights || typeof e.insights !== 'object') return false
  const insights = e.insights as Record<string, unknown>
  if (!insights.sharedTeamView || typeof insights.sharedTeamView !== 'object') return false
  if (!insights.personalView || typeof insights.personalView !== 'object') return false
  return true
}

export function parseLiveMeetingInsightsRealtimeWsMessage(
  raw: string,
): LiveMeetingInsightsRealtimeEnvelopeV1 | null {
  try {
    const msg = JSON.parse(raw) as {
      type?: string
      envelope?: LiveMeetingInsightsRealtimeEnvelopeV1
    }
    if (
      msg.type === LIVE_MEETING_INSIGHTS_REALTIME_KIND &&
      msg.envelope?.kind === LIVE_MEETING_INSIGHTS_REALTIME_KIND &&
      isValidLiveMeetingInsightsRealtimeEnvelope(msg.envelope)
    ) {
      return msg.envelope
    }
  } catch {
    /* ignore */
  }
  return null
}
